module.exports = __webpack_public_path__ + "img/arrow-left-circle-thin.1bd6cd2c.svg";